import {ref, Ref, watch} from 'vue';
import {ElMessage} from 'element-plus';
import {DASHBOARD_ORGANISATIES, FINANCE_THEMES} from 'common';
import {localStorageGetJson, localStorageSetJson} from '@/base/utils.js';

const STORAGE_PERIOD_ID: string   = 'dashboard:period';
const STORAGE_ORGS_ID: string     = 'dashboard:orgs';
const STORAGE_THEMAS_ID: string   = 'dashboard:themas';
const STORAGE_PROGNOSE_ID: string = 'dashboard:inclPrognose';

// stored labels that no longer exist (renamed groups) are dropped, otherwise no button looks selected
function storedOrgs(): string[] {
    const stored: string[] = localStorageGetJson(STORAGE_ORGS_ID) ?? [];
    return stored.filter((l: string) => DASHBOARD_ORGANISATIES.some(o => o.label === l));
}

function storedThemas(): string[] {
    const stored: string[] = localStorageGetJson(STORAGE_THEMAS_ID) ?? [];
    return stored.filter((l: string) => FINANCE_THEMES.some(t => t.label === l));
}

// the quarter and organisation groups chosen in the dashboard header, shared by every dashboard tab
export const dashboardPeriod: Ref<string> = ref<string>(localStorageGetJson(STORAGE_PERIOD_ID) ?? '');
export const dashboardOrgs: Ref<string[]> = ref<string[]>(storedOrgs());

// the finance theme labels chosen on the Financien page (none is all) and the prognose Q+1 toggle
export const dashboardThemas: Ref<string[]>      = ref<string[]>(storedThemas());
export const dashboardInclPrognose: Ref<boolean> = ref<boolean>(localStorageGetJson(STORAGE_PROGNOSE_ID) ?? true);

watch(dashboardPeriod, (p: string) => localStorageSetJson(STORAGE_PERIOD_ID, p));
watch(dashboardOrgs, (o: string[]) => localStorageSetJson(STORAGE_ORGS_ID, o));
watch(dashboardThemas, (t: string[]) => localStorageSetJson(STORAGE_THEMAS_ID, t));
watch(dashboardInclPrognose, (p: boolean) => localStorageSetJson(STORAGE_PROGNOSE_ID, p));

// a dashboard backend call with one error message for the user; undefined when it failed
export async function laadDashboard<T>(call: () => Promise<T>): Promise<T | undefined> {
    try {
        return await call();
    } catch (e) {
        console.error('dashboard call failed', e);
        ElMessage.error('Dashboard laden mislukt');
        return undefined;
    }
}
